import _slicedToArray from "/Users/phris/Workspace/yunssl/yunssl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/Users/phris/Workspace/yunssl/yunssl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/phris/Workspace/yunssl/yunssl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/phris/Workspace/yunssl/yunssl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/phris/Workspace/yunssl/yunssl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "/Users/phris/Workspace/yunssl/yunssl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/phris/Workspace/yunssl/yunssl-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { startInactiveSpan } from '@sentry/browser';
import { withActiveSpan, spanToJSON } from '@sentry/core';
import { timestampInSeconds } from '@sentry/utils';
import hoistNonReactStatics from 'hoist-non-react-statics';
import * as React from 'react';
import { REACT_MOUNT_OP, REACT_UPDATE_OP, REACT_RENDER_OP } from './constants.js';
var _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/profiler.tsx";
var UNKNOWN_COMPONENT = 'unknown';

/**
 * The Profiler component leverages Sentry's Tracing integration to generate
 * spans based on component lifecycles.
 */
var Profiler = /*#__PURE__*/function (_React$Component) {
  _inherits(Profiler, _React$Component);
  _createClass(Profiler, null, [{
    key: "__initStatic",
    /**
     * The span of the mount activity
     * Made protected for the React Native SDK to access
     */
    /**
     * The span that represents the duration of time between shouldComponentUpdate and componentDidUpdate
     */
    // eslint-disable-next-line @typescript-eslint/member-ordering
    value: function __initStatic() {
      this.defaultProps = {
        disabled: false,
        includeRender: true,
        includeUpdates: true
      };
    }
  }]);
  function Profiler(props) {
    var _this;
    _classCallCheck(this, Profiler);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Profiler).call(this, props));
    var _this$props = _this.props,
      name = _this$props.name,
      _this$props$disabled = _this$props.disabled,
      disabled = _this$props$disabled === void 0 ? false : _this$props$disabled;
    if (disabled) {
      return _possibleConstructorReturn(_this);
    }
    _this._mountSpan = startInactiveSpan({
      name: "<".concat(name, ">"),
      onlyIfParent: true,
      op: REACT_MOUNT_OP,
      origin: 'auto.ui.react.profiler',
      attributes: {
        'ui.component_name': name
      }
    });
    return _this;
  }

  // If a component mounted, we can finish the mount activity.
  _createClass(Profiler, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._mountSpan) {
        this._mountSpan.end();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref) {
      var _this2 = this;
      var updateProps = _ref.updateProps,
        _ref$includeUpdates = _ref.includeUpdates,
        includeUpdates = _ref$includeUpdates === void 0 ? true : _ref$includeUpdates;
      // Only generate an update span if includeUpdates is true, if there is a valid mountSpan,
      // and if the updateProps have changed. It is ok to not do a deep equality check here as it is expensive.
      // We are just trying to give baseline clues for further investigation.
      if (includeUpdates && this._mountSpan && updateProps !== this.props.updateProps) {
        // See what props haved changed between the previous props, and the current props. This is
        // set as data on the span. We just store the prop keys as the values could be potenially very large.
        var changedProps = Object.keys(updateProps).filter(function (k) {
          return updateProps[k] !== _this2.props.updateProps[k];
        });
        if (changedProps.length > 0) {
          var now = timestampInSeconds();
          this._updateSpan = withActiveSpan(this._mountSpan, function () {
            return startInactiveSpan({
              name: "<".concat(_this2.props.name, ">"),
              onlyIfParent: true,
              op: REACT_UPDATE_OP,
              origin: 'auto.ui.react.profiler',
              startTimestamp: now,
              attributes: {
                'ui.component_name': _this2.props.name,
                'ui.react.changed_props': changedProps
              }
            });
          });
        }
      }
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this._updateSpan) {
        this._updateSpan.end();
        this._updateSpan = undefined;
      }
    } // If a component is unmounted, we can say it is no longer on the screen.
    // This means we can finish the span representing the component render.
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var endTimestamp = timestampInSeconds();
      var _this$props2 = this.props,
        name = _this$props2.name,
        _this$props2$includeR = _this$props2.includeRender,
        includeRender = _this$props2$includeR === void 0 ? true : _this$props2$includeR;
      if (this._mountSpan && includeRender) {
        var startTimestamp = spanToJSON(this._mountSpan).timestamp;
        withActiveSpan(this._mountSpan, function () {
          var renderSpan = startInactiveSpan({
            onlyIfParent: true,
            name: "<".concat(name, ">"),
            op: REACT_RENDER_OP,
            origin: 'auto.ui.react.profiler',
            startTimestamp: startTimestamp,
            attributes: {
              'ui.component_name': name
            }
          });
          if (renderSpan) {
            // Have to cast to Span because the type of _mountSpan is Span | undefined
            // and not getting narrowed properly
            renderSpan.end(endTimestamp);
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return Profiler;
}(React.Component);
Profiler.__initStatic();

/**
 * withProfiler is a higher order component that wraps a
 * component in a {@link Profiler} component. It is recommended that
 * the higher order component be used over the regular {@link Profiler} component.
 *
 * @param WrappedComponent component that is wrapped by Profiler
 * @param options the {@link ProfilerProps} you can pass into the Profiler
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withProfiler(WrappedComponent,
// We do not want to have `updateProps` given in options, it is instead filled through the HOC.
options) {
  var _this3 = this;
  var componentDisplayName = options && options.name || WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
  var Wrapped = function Wrapped(props) {
    return React.createElement(Profiler, _objectSpread({}, options, {
      name: componentDisplayName,
      updateProps: props,
      __self: _this3,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 159
      }
    }), React.createElement(WrappedComponent, _objectSpread({}, props, {
      __self: _this3,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 160
      }
    })));
  };
  Wrapped.displayName = "profiler(".concat(componentDisplayName, ")");

  // Copy over static methods from Wrapped component to Profiler HOC
  // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  hoistNonReactStatics(Wrapped, WrappedComponent);
  return Wrapped;
}

/**
 *
 * `useProfiler` is a React hook that profiles a React component.
 *
 * Requires React 16.8 or above.
 * @param name displayName of component being profiled
 */
function useProfiler(name) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    disabled: false,
    hasRenderSpan: true
  };
  var _React$useState = React.useState(function () {
      if (options && options.disabled) {
        return undefined;
      }
      return startInactiveSpan({
        name: "<".concat(name, ">"),
        onlyIfParent: true,
        op: REACT_MOUNT_OP,
        origin: 'auto.ui.react.profiler',
        attributes: {
          'ui.component_name': name
        }
      });
    }),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    mountSpan = _React$useState2[0];
  React.useEffect(function () {
    if (mountSpan) {
      mountSpan.end();
    }
    return function () {
      if (mountSpan && options.hasRenderSpan) {
        var startTimestamp = spanToJSON(mountSpan).timestamp;
        var endTimestamp = timestampInSeconds();
        var renderSpan = startInactiveSpan({
          name: "<".concat(name, ">"),
          onlyIfParent: true,
          op: REACT_RENDER_OP,
          origin: 'auto.ui.react.profiler',
          startTimestamp: startTimestamp,
          attributes: {
            'ui.component_name': name
          }
        });
        if (renderSpan) {
          // Have to cast to Span because the type of _mountSpan is Span | undefined
          // and not getting narrowed properly
          renderSpan.end(endTimestamp);
        }
      }
    };
    // We only want this to run once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
export { Profiler, UNKNOWN_COMPONENT, useProfiler, withProfiler };